export class CanalEntrada {
  id: number = 0;
  descripcion: string = '';
  filtroEntidad: string = '';
  esPrescriptor: boolean;
  activo: boolean = true;
  createdBy: string;
  updatedBy: string;
  updatedDate: string;
  createdDate: string;
  createdByName: string;
  updatedByName: string;
}
